import { ICommodity, ITransportationManagementSystem } from 'types/graphqlTypes'
import { IShipperTrackingSegment } from 'types/shipment'
import { IUser } from 'types/user'

export enum PaymentTerms {
  NET_TERMS = 'net_terms',
  PRE_PAY = 'pre_pay',
}

export type TShipperCreditCheckStatus = 'in_review' | 'declined' | 'approved'

export interface IShipper {
  occurrenceAmount: any
  accountingEmail: string
  autoAcceptEnabled: boolean
  autoAcceptMetadata: IAutoAcceptMetadata
  canRespondToTender: boolean
  carrierInstructions: string
  schedulingInstructions: string
  cohortQuarter?: number
  cohortYear?: number
  contactReferer: Partial<IUser>
  contactRefererId: string
  defaultPaymentTerms: string
  emailDomain: string
  headquarter: {
    address: string
    city: string
    contactName: string
    contactPhone: string
    contactPhoneExt?: string
    countryCode: string
    stateCode: string
    zipcode: string
  }
  shipperBtfCalculationDetails: {
    btfRequired?: boolean
    btfBaseRate?: number
    btfMpg?: number
  }
  financeRep: Partial<IUser>
  financeRepId?: string | null
  id: string
  invoicingMethod: string
  invoicingNotes: string
  isFsmaApproved: boolean
  isKeyAccount: boolean
  name: string
  netsuiteId: string
  opsRep: Partial<IUser>
  opsRepId: string
  paymentPreference: string
  creditLimit: number
  creditCheckStatus?: TShipperCreditCheckStatus
  dunsNumber: string
  opsCustomerEmail: string
  paymentTermsType: PaymentTerms
  podId: number
  podRequired: boolean
  rateType: string
  saleRep: Partial<IUser>
  saleUserId: string
  secondaryAccountingEmail: string
  segment: string
  shipmentEmail: string
  shipperTrackingSegment?: IShipperTrackingSegment
  shipperTrackingSegmentId?: string
  state: string
  generalInsuranceRequirement: IGeneralInsuranceRequirement
  automotiveInsuranceRequirement: IAutomotiveInsuranceRequirement
  cargoInsuranceRequirement: ICargoInsurancRequirement
  workersCompensationInsuranceRequirement: IWorkersCompensationInsuranceRequirement
  isFuelRateAdjusting: boolean
  accessorialContactEmail: string
  commoditiesStatus: 'in_review' | 'approved' | 'declined'
  companyWebsite: string
  commodityId: number | null
  commodity: Pick<ICommodity, 'id' | 'description'> | null
  rateTypesExpected: string[] | null
  vertical: string | null
  transportationManagementSystems: Pick<ITransportationManagementSystem, 'id' | 'name'>[]
  seasonality: string[] | null
  billingPortal: string
  updatedAt: string
  requireBtf: boolean
}

export interface IGeneralInsuranceRequirement {
  id: string
  aggregateAmount: string
  occurrenceAmount: string
}

export interface IAutomotiveInsuranceRequirement {
  id: string
  occurrenceAmount: string
  combinedSingleLimitAmount: string
}

export interface ICargoInsurancRequirement {
  id: string
  liabilityAmount: string
  hasUnattendedVehicleCoverage: boolean
  hasTheftCoverage: boolean
  hasCommodityCoverage: boolean
  requiredCommodities: number[] | null
}

export interface IWorkersCompensationInsuranceRequirement {
  id: string
  requirementType: string
}

export enum SortOrder {
  asc = 'asc',
  desc = 'desc',
}

export interface IFuelRateParams {
  fuelRate: string
  id: string
  rangeEnd: string
  rangeStart: string
}

export interface IAutoAcceptMetadata {
  acceptLogic: {
    spot: string[]
    contract: string[]
    bup: string[]
    tracking: string[]
  }
  rejectLogic: {
    spot: string[]
    contract: string[]
    bup: string[]
    tracking: string[]
  }
}
